import { useQuery } from 'react-query';
import { axios, AxiosQueryResponse } from '../utils/axios';
import { apiResourceLinks } from '../constants/apiResourceLinks';
import { ConciergeUser } from '../types/user';

const getConciergeUser = async () => {
  const { data }: AxiosQueryResponse = await axios.get(apiResourceLinks.myUser, {
    params: {}
  });
  return data;
};

export const useConciergeUserQuery = () => {
  return useQuery<ConciergeUser>(['conciergeUserQuery'], () => getConciergeUser(), {
    onSuccess: (data) => {
      return data;
    },
    onError: () => {}
  });
};
